import { Injectable } from '@angular/core';
import { Permission } from '../enums/permission.enum';
import { Rol } from '../enums/rol.enum';
import { getPermissionsForRoles } from '../constants/role-permissions';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  constructor(private authService: AuthService) {}

  private getUserRoles(): Rol[] {
    const userData = this.authService.getUser();
    const roles: string[] = userData?.user?.roles ?? [];
    return roles.filter((r): r is Rol => Object.values(Rol).includes(r as Rol));
  }

  hasRole(role: Rol): boolean {
    return this.getUserRoles().includes(role);
  }

  hasPermission(permission: Permission): boolean {
    const permissions = getPermissionsForRoles(this.getUserRoles());
    return permissions.includes(permission);
  }

  getPermissions(): Permission[] {
    return getPermissionsForRoles(this.getUserRoles());
  }

  getRoles(): Rol[] {
    return this.getUserRoles();
  }
}
